import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function useSaved() {
  const { user } = useAuth();
  const [savedIds, setSavedIds] = useState(new Set());

  const load = useCallback(async () => {
    if (!user) return;
    try {
      const res = await api.get("/saved");
      setSavedIds(new Set(res.data.filter((i) => i.item_type === "opportunity").map((i) => i.item_id)));
    } catch {}
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const toggleSave = async (opp) => {
    if (!user) { window.location.href = "/login"; return; }
    const id = opp.slug;
    if (savedIds.has(id)) {
      setSavedIds((s) => { const n = new Set(s); n.delete(id); return n; });
      await api.delete(`/saved/opportunity/${id}`);
      toast("Removed from saved");
    } else {
      setSavedIds((s) => new Set(s).add(id));
      await api.post("/saved", { item_type: "opportunity", item_id: id, title: opp.title });
      toast.success("Saved to workspace");
    }
  };

  return { savedIds, toggleSave, reload: load };
}
